import React, { useRef, useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import videoUno from '../assets/reel-uno.mp4';
import videoDos from '../assets/reel-dos.mp4';
import videoTres from '../assets/reel-tres.mp4';

const QuienesSomos: React.FC = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);
  
  const videos = [videoUno, videoDos, videoTres];

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.75;
    }
  }, []);

  const handleVideoEnded = () => {
    // Cuando termina un video, pasar al siguiente
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  return (
    <div className="quienes-somos-container">
      <div className="video-background">
        <video
          ref={videoRef}
          key={currentVideoIndex} // Forzar re-render cuando cambia el video
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnded}
          className="background-video"
        >
          <source src={videos[currentVideoIndex]} type="video/mp4" />
        </video>
        <div className="video-overlay" />
      </div>
      
      <Container className="py-4 content-overlay">
        <Row className="justify-content-center">
          <Col md={10} lg={9} className="text-center">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="display-4 mb-4 brand-font"
            >
              Somos tu club de vinos
            </motion.h1>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="text-content"
            >
              <p className="lead mb-4">
                Bienvenido al lugar que te merecés para disfrutar del vino. Seleccionamos cuidadosamente etiquetas de excelencia para vos, trabajamos con gran variedad de bodegas y marcas con el objetivo de que tu disfrute empiece desde la compra.
              </p>
              <p className="lead mb-4">
                Juntos vamos a guiarte en el apasionante mundo de descubrir cuál es la uva ideal para vos, nuestra asesoría personalizada te va a ayudar a armar tu combo ideal.
              </p>
              <p className="lead mb-4">
                Queremos que te sientas parte del club, y es por eso que siempre vamos a buscar
                <br />
                <strong className="extra-bold">el mejor precio para vos</strong>.
              </p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, duration: 0.5 }}
                className="mt-4"
              >
                <Link to="/lista-precios">
                  <Button variant="outline-light" size="lg" className="elegant-button">
                    ¡Descubrí nuestros productos!
                  </Button>
                </Link>
              </motion.div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default QuienesSomos; 